import React, { useState } from 'react'
import {
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Nav,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  Row,
} from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useFieldArray, useForm,Controller } from "react-hook-form";
import {
    useNavigate,
    useParams
  } from "react-router-dom";
import useMessageTypeQuery from 'services/contact';
import NavTabsItem from 'shared/components/Tabs';
interface IProps {

}

const EditMessageType: React.FC<IProps>= (props) =>{
  const params = useParams();
  let navigate = useNavigate();

  const { data: MessageTypes,isLoading } = useMessageTypeQuery.useGetSingle(params.id)

  const [activeTab, setActiveTab] = useState('1');
  const {  control, handleSubmit, } = useForm();
  const { fields, append } = useFieldArray({
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "message_type", // unique name for your Field Array
  });
  React.useEffect(() => {
    if (MessageTypes) {
    MessageTypes.forEach((tm, index) => {
        append(tm);
      });
    }
  }, [MessageTypes]);
  const onSuccessSubmit = () => {
    toast('MessageType updated', {
        duration: 2000,
        position: 'top-center',
        icon: '👍🏻',
      });
    setTimeout(() => {
        navigate(-1)
    }, 1000);
}
  
const {
  mutate: mutateMessageTypeUpdate,
} = useMessageTypeQuery.useUpdate(onSuccessSubmit);
const onSubmit = (data: any) => {
  const { message_type } =data
  message_type.map(
   (el:any)=>
    {
      delete el['unique_identifier']
    }
  )
  mutateMessageTypeUpdate(message_type)
};

  return (
    <>
    {isLoading ? (
        <div>Loading...</div>
        ) : (
        <Card className="mt-3">
        <Toaster />
        <CardBody>
            <h4 className="header-title">MessageType</h4>
            <Form onSubmit={handleSubmit(onSubmit)}>
            <Nav tabs>
                {fields?.map((i: any, index) => (
                <>
                    <NavItem>
                    <NavLink
                        className={activeTab === `${index + 1}` ? "active" : ""}
                        onClick={function noRefCheck() {
                        setActiveTab(`${index + 1}`);
                        }}
                    >
                        <NavTabsItem item={i}/>
                    </NavLink>
                    </NavItem>
                </>
                ))}
            </Nav>
            <TabContent activeTab={activeTab}>
                {fields?.map((i: any, index) => (
                <TabPane tabId={(index + 1).toString()} key={i.id}>
                    <Row>
                    <Col sm="12">
                        <div>
                        <FormGroup row >
                                        <Label for="priority" sm={3}>
                                            Name
                                        </Label>
                                        <Col sm={9}>
                                        <Controller
                                            name={`message_type.${index}.priority`}
                                            control={control}
                                            render={({ field }) => (
                                            <Input {...field} type="number" id="priority" />
                                            )}
                                        />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row >
                                        <Label for="name" sm={3}>
                                            Name
                                        </Label>
                                        <Col sm={9}>
                                        <Controller
                                            name={`message_type.${index}.name`}
                                            control={control}
                                            render={({ field }) => (
                                            <Input {...field} type="text" id="text" />
                                            )}
                                        />
                                        </Col>
                                    </FormGroup>
                                    
                        </div>
                    </Col>
                    </Row>
                </TabPane>
                ))}
            </TabContent>
            <Button color="primary" type="submit">
                Submit
            </Button>
            </Form>
        </CardBody>
        </Card>
    )}
    </>
  );
}

export default EditMessageType